module.exports = __webpack_public_path__ + "img/new_seed_logo.1fa92f46.png";